import React, {PureComponent, ReactNode} from 'react';
import {getLinkPath} from 'app/utils';
import I18n from 'app/i18n';

export default class FastRegistrationTerms extends PureComponent {
    render(): ReactNode {
        return <div className="registration-terms" dangerouslySetInnerHTML={{
            __html: I18n.t('service_agree_registration', {
                user_agreement_link: `<a target="_blank"
                href=${getLinkPath('/terms_and_conditions')}>${I18n.t('user_agreement')}</a>`
            })
        }}/>;
    }
}
